function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { List, Typography, Alert } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Receipt = function Receipt(_ref) {
  var options = _ref.options,
      serviceTree = _ref.serviceTree,
      _ref$company = _ref.company,
      company = _ref$company === void 0 ? null : _ref$company;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      rdata = _useState2[0],
      setRdata = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      itemsArray = _useState4[0],
      setItemsArray = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedItems = _useState6[0],
      setSelectedItems = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      totalAmount = _useState8[0],
      setTotalAmount = _useState8[1];

  useEffect(function () {
    var optArray = options.toString().split(",");
    serviceTree.forEach(function (d) {
      d.services.forEach(function (s) {
        optArray.forEach(function (o) {
          s.medical_items.forEach(function (i) {
            if (i.id.toString() == o.toString()) {
              setRdata(function (prev) {
                return [].concat(_toConsumableArray(prev), [i.label + " - " + i.base_price.toLocaleString('fr') + " GNF"]);
              });
              setTotalAmount(function (prev) {
                return prev + i.base_price;
              });
            }
          });
        });
      });
    });

    if (company != null) {
      setTotalAmount(function (prev) {
        return prev * (100 - company.rate) * 0.01;
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      header: /*#__PURE__*/_jsx("div", {
        children: "Actes / Examens factur\xE9s"
      }),
      footer: /*#__PURE__*/_jsx("b", {
        children: "TOTAL (GNF) " + totalAmount.toLocaleString('fr')
      }),
      bordered: true,
      dataSource: rdata,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsx(List.Item, {
          children: /*#__PURE__*/_jsx(Typography.Text, {
            mark: true,
            children: item
          })
        });
      }
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), company != null && /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      banner: true,
      message: "Prise en charge de " + company.rate.toString() + "% par " + company.label
    })]
  });
};

export default Receipt;